import { LOCALES } from '@/i18n/locales'

const LOCALE_SEGMENTS = new Set<string>(LOCALES)

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const NUMERIC = /^\d+$/
const LONG_TOKEN = /^[A-Za-z0-9_-]{16,}$/

function isIdentifier(segment: string): boolean {
  return UUID.test(segment) || NUMERIC.test(segment) || LONG_TOKEN.test(segment)
}

// Route without identifiers or locale: the only path-derived value we collect.
export function normalizeRoute(pathname: string): string {
  const path = pathname.split(/[?#]/, 1)[0]
  const segments = path.split('/').filter(Boolean)
  if (segments.length > 0 && LOCALE_SEGMENTS.has(segments[0])) {
    segments.shift()
  }
  if (segments.length === 0) return '/'
  return `/${segments.map(s => (isIdentifier(s) ? '[id]' : s)).join('/')}`
}
